import { EventApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function useUpdateContents() {
  const queryClient = useQueryClient();

  return useAuthMutation(EventApi.putContents, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).detail(String(variables.id || '')),
      });
    },
  });
}

export default useUpdateContents;
